import { handleActions } from 'redux-actions';
import {
  appContainerSettingFetchInitialized,
  appContainerSettingFetchSucceeded,
  appContainerSettingFetchFailed,
  appContainerSettingUpdateSucceeded,
} from '../ContainerSettings';

export interface ISecureCookieValue {
  // eslint-disable-next-line camelcase
  is_enabled?: boolean
}

export interface ISecureCookieAttributes {
  // eslint-disable-next-line camelcase
  is_custom?: boolean
  value: ISecureCookieValue
}

export interface IAppSecureCookieSettingData {
  id: string
  type: string
  attributes: ISecureCookieAttributes
}

export interface IAppSecureCookieResponse {
  data?: IAppSecureCookieSettingData
}

export interface ISecureCookieState {
  isLoading: boolean
  failed: boolean
  value?: ISecureCookieValue | null
}

const initialState: ISecureCookieState = {
  isLoading: true,
  failed: false,
  value: null,
};

export default handleActions<ISecureCookieState, IAppSecureCookieResponse>({
  [appContainerSettingFetchInitialized('secure_cookies').toString()]: () => initialState,
  [appContainerSettingFetchSucceeded('secure_cookies').toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    isLoading: false,
    value: {
      ...state.value,
      ...payload.data!.attributes.value,
    },
  }),
  [appContainerSettingFetchFailed('secure_cookies').toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
  [appContainerSettingUpdateSucceeded('secure_cookies').toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    value: {
      ...state.value,
      ...payload.data!.attributes.value,
    },
  }),
}, initialState);
